import $ from 'jquery';
import { debounce } from 'underscore';

export default class JobDetail {
	init() {
		const $jobFormHeader = $('.job-header');
		const $jobDetailContainer = $('.atl-job-detail');
		const $mediaHeader = $('.atl_media_header');
		const $jobTags = $('.job-tags');
		const $breadCrumb = $('.section-breadcrumb');
		const $form = $('.atl-form').parent();
		const $backlink = $('.job-header .back-link');
		const $contactPerson = $('.form-contact-person');
		const $contactPlaceholder = $('#current-contact');
		const $contactTarget = $('.contact-person.container');
		let jumpToPosition;
		let jobTagsTop;
		const MoveJobDetailsToTop = () => {
			if ($jobFormHeader.length) {
				$jobFormHeader.css('margin-top', 0);
			} else if ($jobDetailContainer.length) {
				$jobDetailContainer.css('margin-top', 0);
			}

			if ($jobTags.length) {
				if ($(window).width() > 992 && $breadCrumb.length) {
					jumpToPosition = $breadCrumb.offset().top;
				} else if ($mediaHeader.length) {
					jumpToPosition =
						$mediaHeader.offset().top + $mediaHeader.outerHeight();
				}
				jobTagsTop = $jobTags.offset().top;
			}

			// not in mobile view!
			if ($(window).width() > 992) {
				if ($jobFormHeader.length) {
					$jobFormHeader.css('margin-top', -(jobTagsTop - jumpToPosition));
				} else if ($jobDetailContainer.length) {
					$jobDetailContainer.css('margin-top', -(jobTagsTop - jumpToPosition));
				}
			} else {
				if ($jobDetailContainer.length) {
					$jobDetailContainer.css('margin-top', -160);
				}
			}
		};
		const AppendBacklinkAfterForm = () => {
			if ($backlink.length && $form.length) {
				const $newLink = $backlink.clone();
				$form.append($newLink);
			}
		};
		const MoveContactPersonAfterSumbitButton = () => {
			if ($contactPerson.length && $form.length) {
				$form.append($contactPerson);
			}
		};
		const TransferContactToContactField = () => {
			const value = $contactPlaceholder.data('content');
			if (value !== '' && undefined !== value) {
				$contactTarget.append(`<div class="text-container">${value}</div>`);
			}
		};
		// end of let!

		MoveJobDetailsToTop();
		MoveContactPersonAfterSumbitButton();
		AppendBacklinkAfterForm();
		TransferContactToContactField();

		$(window).resize(
			debounce(() => {
				MoveJobDetailsToTop();
			}, 250),
		);
	}
}
